import _classCallCheck from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "C:\\Users\\Utente\\Documents\\GitHub\\PegasoWebApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import CalEvent from './CalEvent.js';
import CalDate from 'caldate';

/**
 * Mapper class for mapped calenders like hijri and hebrew
 * `this.calender` needs to be set in child classes
 */
var CalEventMap = /*#__PURE__*/function (_CalEvent) {
  _inherits(CalEventMap, _CalEvent);
  var _super = _createSuper(CalEventMap);
  function CalEventMap(opts) {
    var _this;
    _classCallCheck(this, CalEventMap);
    _this = _super.call(this, opts);
    _this.calendar = {};
    return _this;
  }
  _createClass(CalEventMap, [{
    key: "inYear",
    value: function inYear(year) {
      if (!(this.calendar[year] && this.calendar[year + 1] && this.calendar[year - 1])) {
        return this;
      }
      for (var y = year - 1; y <= year + 1; y++) {
        // resolve date in `calendar` as gregorian date
        var firstDays = this.calendar[y][this.opts.month - 1];
        // firstDays `[M, D, diffYear, ...] | null`
        if (!firstDays) {
          continue;
        }
        for (var i = 0; i < firstDays.length; i += 3) {
          if (this.opts.year) {
            var calYear = this.calendar.year + firstDays[i + 2];
            if (this.opts.year !== calYear) {
              continue;
            }
          }
          var d = new CalDate({
            year: y,
            month: firstDays[i] + 1,
            day: firstDays[i + 1]
          }).setOffset(this.opts.day - 1);
          if (d.year === year) {
            this.dates.push(d);
          }
        }
      }
      return this;
    }
  }]);
  return CalEventMap;
}(CalEvent);
export { CalEventMap as default };